import http from '@/plugins/axios';

export async function get_dashboard(payload) {
  const response = await http.get('report/summary_sale_report', { params: payload });
  return response.data;
}


export async function summary_sale_report_by_category(payload) { 
  const response = await http.get('report/summary_sale_report_by_category', { params: payload });
  return response.data;
}

export async function top_sale_items(payload) { 
  const response = await http.get('report/top-sale-items', { params: payload });
  return response.data;
}



